import Button from '@/src/v2/components/Button/Button';
import { useState, useEffect } from 'react';
import style from './login.module.scss';
const LOCKOUT_DURATION = 60; // Lockout duration in seconds

const LockTimer: React.FC<{ setDisableLogin: any }> = ({ setDisableLogin }) => {
  const [remainingTime, setRemainingTime] = useState<number>(0);

  useEffect(() => {
    try {
      const lockoutExpiry = localStorage.getItem('lockoutExpiry');
      const now = Date.now();
      const expiryTime = Number(lockoutExpiry);
      if (lockoutExpiry && !isNaN(expiryTime) && expiryTime > now) {
        const timeLeft = Math.ceil((expiryTime - now) / 1000);
        setRemainingTime(timeLeft);
      }
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      setRemainingTime(0);
    }
    const interval = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          localStorage.removeItem('lockoutExpiry'); // Clear expiry when timer ends
          setDisableLogin(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval); // Cleanup timer on component unmount
  }, []);
  function minTwoDigits(n: number) {
    return (n < 10 ? '0' : '') + n;
  }
  return (
    <>
      {remainingTime > 0 && (
        <>
          <Button
            type="secondary-v2"
            label={`00:${minTwoDigits(remainingTime)}`}
            onClick={() => {}}
            className={style['login-modal__form__loginbtn']}
          />
          <div style={{ margin: '16px 0' }}>
            <span>
              You've Reached the Maximum Number of Login Attempts. Please Wait
              60 Seconds Before Trying Again
            </span>
          </div>
        </>
      )}
    </>
  );
};

export default LockTimer;
